import React from "react";
import { TOOLTIP_MESSAGES } from '../../../bento/cohortModalData';

export const exploreCCDIHubTooltip = <p style={{ fontFamily: "Poppins", zIndex: 10000, fontWeight: 400, fontSize: 13, margin: 0 }}>
    {TOOLTIP_MESSAGES.exploreCCDIHub.mainText}
</p>;

export const exploreDashboardTooltip = <p style={{ fontFamily: "Poppins", zIndex: 10000, fontWeight: 400, fontSize: 13, margin: 0 }}>
    Clicking this button will create a pre-filtered facet for further analysis on the Explore Dashboard

</p>;
